<!-- 
    描述：外部对接字典
    时间： 2021/03/02
    Created by zl
-->
<template>
	<div class="dict-layout">
		<w-split class="h100"
				 v-model="splitL">
			<div class="w-page-main left"
				 slot="left">
				<div class="w-page-header">
					<div class="left-text overflow-hidden">
						<span class="fontSize16">外部对接平台</span>
					</div>
					<div class="btnGroups ml10">
						<el-button type="primary"
								   size="small"
								   class="blue btnWidth"
								   v-if="roleBtns.includes('add_platform')"
								   @click="addClick('addPlatform')">添 加</el-button>
					</div>
				</div>
				<div class="w-page-container pdb10">
					<LeftPlatformTable ref="platformTable"
									   @rowClick="rowClick"></LeftPlatformTable>
				</div>
			</div>
			<div class="w-page-main right"
				 slot="right">
				<div class="w-page-header">
					<div class="left-text overflow-hidden">
						<span class="fontSize16">关联的字典表</span>
					</div>
					<search-area v-model="searchForm.sname"
								 :showMore="false"
								 placeholderName="平台名称"
								 @on-search="onSearch"
								 @on-refresh="onRefresh"
								 @on-reset="onReset">
					</search-area>
					<div class="btnGroups ml10">
						<el-button type="primary"
								   size="small"
								   class="blue btnWidth"
								   v-if="roleBtns.includes('add_associative_dict')"
								   @click="addClick('addAssociated')">添加关联</el-button>
					</div>
				</div>
				<div class="w-page-container pdb10">
					<RightDictionaryTable ref="dictTable"></RightDictionaryTable>
				</div>
			</div>
		</w-split>
	</div>
</template>
<script>
import LeftPlatformTable from './components/LeftPlatformTable'
import RightDictionaryTable from './components/RightDictionaryTable'
import { mapState } from 'vuex'
export default {
	name: 'ExternalDictionary',
	components: {
		LeftPlatformTable,
		RightDictionaryTable,
	},
	data() {
		return {
			splitL: 0.25,
			searchForm: {
				sname: '',
			},
		}
	},
	created() {},
	methods: {
		// 外部对接平台添加
		addClick(type) {
			type == 'addPlatform'
				? this.$refs.platformTable.doClick('add')
				: this.$refs.dictTable.doClick('')
		},

		// 左侧table点击
		rowClick(data) {
			if (data) {
				this.$refs.dictTable.getDictList()
				this.$refs.dictTable.leftObj = data
			}
		},

		// 确认搜索
		onSearch() {
			this.$refs.dictTable.searchTablePageList(this.searchForm)
		},

		// 点击刷新
		onRefresh() {
			this.onReset()
			this.onSearch()
		},

		// 点击重置
		onReset() {
			this.searchForm.sname = ''
			this.$refs.dictTable.getAssociatedList()
		},
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns, //按钮权限
		}),
	},
}
</script>
<style lang='less' scoped>
.dict-layout {
	height: 100%;
	background-color: #fff;

	.blue {
		background-color: #2671cc;
	}

	.fontSize16 {
		font-size: 16px !important;
		font-weight: normal !important;
	}

	.btnWidth {
		width: 80px !important;
	}
}
</style>
